$(function() {
    // いいね／お気に入りボタンを押したときの処理
    var toggleMarkFail = function(btnObj,countObj,count,checked,message) {
        alert(message);    
        // カウンターを戻す
        countObj.text(count);
        // ボタンを戻す
        btnObj.prop('checked',!checked);
        return false;
    }
    var postFavoriteApi = function(btnObj) {
        // カウンター更新
        var countObj = btnObj.parents('form').find('.icn-movie-num'),
            checked  = btnObj.prop("checked"),
            count    = parseInt(countObj.text()),
            afterCount = (checked) ? count + 1 : count - 1;
        countObj.text(afterCount);

        var postData = {
            type: 'POST',
            dataType: 'json',
            processData: false,
            contentType: false,
        }
        $.ajax(btnObj.parents('form').attr('data-api-url'),postData)
            .done(function(data) { 
                if(!data.status)
                    toggleMarkFail(btnObj,countObj,count,checked,data.message); 
             })
            .fail(function() { 
                toggleMarkFail(btnObj,countObj,count,checked,(btnObj.hasClass('favorite-button')) ? "お気に入りできませんでした。" : "いいねできませんでした。"); 
            });
    }
    $('#area-vodDetail .good-button').on('change',function() { postFavoriteApi($(this)); });
    $('#area-vodAbout .good-button').on('change',function() { postFavoriteApi($(this)); });
    $('#area-vodDetail .favorite-button').on('change',function() { postFavoriteApi($(this)); });
    $('#area-vodAbout .favorite-button').on('change',function() { postFavoriteApi($(this)); });

    // 一覧/詳細の購入ボタンを押したときの処理
    $('.movie-purchase--button').on('click',function() {
        // モーダルに情報をセットする
        var modalObj = $('#area-event-modal');
        modalObj.find('.title').text($(this).attr("data-title"));
        modalObj.find('.thumbnail').attr('src',$(this).attr("data-thumbnail"));
        modalObj.find('.price').text($(this).attr("data-price"));
        modalObj.find('.alert-premium-only').hide();
        modalObj.find('.movie-purchase-exec--button')
                .attr('data-movie-id',$(this).attr("data-movie-id"))
                .prop('disabled',false);
        if($(this).attr('data-user-is-premium') == 0 && $(this).attr('data-premium') == 1) 
            modalObj.find('.alert-premium-only').show();
        modalObj.find('.alert-purchasing').hide();
        modalObj.find('.modal-body-complete').hide();
        modalObj.find('.modal-body-purchase').show();
        modalObj.show();

        var btnsObj = modalObj.find('.modal-body-purchase button');
        btnsObj.show();
        return false;
    });

    var modalClose = function() {
        var modalObj = $('#area-event-modal');
        modalObj.hide();
        return false;
    }
    $('#area-event-modal .movie-purchase-close--button').on('click',modalClose);
    // 購入するボタンを押したときの処理
    $('#area-event-modal .movie-purchase-exec--button').on('click',function() {
        var modalObj = $('#area-event-modal');
        modalObj.find('.alert-purchasing').show();
        // 連打抑止
        var btnsObj = modalObj.find('button');
        btnsObj.prop('disabled',true);

        // 注文送信
        var formObj = new FormData();
        formObj.append('csrf_token',$('meta[name="csrf-token"]').attr('content'));
        // クーポン使用済の場合
        if(modalObj.find('input[name=coupon_id]').prop('checked'))
            formObj.append('coupon_id',modalObj.find('input[name=coupon_id]').val());
        var movieID = $(this).attr('data-movie-id');

        var postData = {
            type: 'POST',
            dataType: 'json',
            data: formObj,
            processData: false,
            contentType: false,
        }
        $.ajax(
            "/api/movie/purchase/"+movieID,
            postData
        )
        // 購入完了
        .done(function(data) { 
            // エラー表示
            if (!data.status)  
                // エラーが返された場合
                switch(data.code){ 
                    case 'already_purchased': 
                        alert(data.error);
                        location.href = '/movie/'+movieID;
                        return false;
                        break;
                    case 'not_premium':
                    case 'not_purchase':
                    case 'credit_error':
                    case 'coupon_not_active':
                        modalObj.find('.alert-purchasing').hide();
                        btnsObj.prop("disabled",false);
                        alert(data.error);
                        return false;
                        break;
                    default:
                        alert('何らかのエラーで購入できませんでした。時間を置いて改めてご購入ください。');
                        return false;
                }
            // 購入完了表示切り替え
            modalObj.find('.alert-purchasing').hide();
            modalObj.find('.modal-body-purchase').hide();
            modalObj.find('.modal-body-complete').show();
            // クーポン使用済の場合
            if(modalObj.find('input[name=coupon_id]').prop('checked'))
                modalObj.find('.box-coupon').hide();

            modalObj.find('.movie-purchase-complete--button').attr('onclick','location.href="/movie/'+movieID+'";return false');
            // 同一画面の購入ボタンを購入済にする
            $('.movie-purchase--button[data-movie-id='+movieID+']').prop("disabled",true).text("購入済");
            btnsObj.prop("disabled",false);
            // 同一画面のvideoタグのURLを差し替える
            $('video').attr('src',data.movie_signed_url);
        })
        // 通信失敗、サーバエラーなど
        .fail(function() { 
            modalObj.find('.alert-purchasing').hide();
            btnsObj.prop("disabled",false);
            alert("購入処理に失敗しました。\n購入メールが届いていない場合、時間を置いて改めてご購入ください。"); 
            return false;
        });
        return false;
    });
});
